import trollFace from '../images/trollFace.png'

const Header = () => {
    return (
        <header className="header">
            <img src={trollFace} alt='logo' className='logo' />
            <h2>Meme Generator</h2>

        </header>
    )
}

export default Header;